import React, { useEffect } from "react";
import { observer } from "mobx-react";
import { Button, Card, Col, Layout, Row, Table, Tag } from "antd";
import { EditOutlined, PlusOutlined } from "@ant-design/icons";
import { rolesStore } from "../../../store/admin/role/RolesStore";
import { Toolbar } from "../../../components/Toolbar";
import { RoleDlg } from "./RoleDlg";

export const Roles = observer(() => {
  const { roleList, loading } = rolesStore;
  useEffect(() => {
    rolesStore.refresh();
  }, []);
  const columns = [ 
    {
      title: "Role Name",
      key: "name",
      sorter: (a, b) => a.name.localeCompare(b.name),
      render: (_, r) => r.name,
    },
    {
      title: "Permissions",
      dataIndex: "permissions",
      key: "permissions",
      render: (permissions) =>
        permissions.map((it: any) => (
          <Row>
            <Col span={8}>{it.res?.name}</Col>
            <Col span={16}>
              {it.opts.map((o: any) => (
                <Tag key={o.code}>{o.name}</Tag>
              ))}
            </Col>
          </Row>
        )),
    },
    {
      title: "Order",
      dataIndex: "sortOrder",
      key: "sortOrder",
      sorter: (a, b) => a.sortOrder - b.sortOrder,
    },
    {
      title: "",
      key: "opt",
      render: (t, r) => <EditOutlined onClick={() => rolesStore.edit.edit(r)} />,
    },
  ];

  return (
    <Layout.Content className="padding24">
      <Toolbar
        actions={
          <Button disabled type="primary" size="large" icon={<PlusOutlined />}>
            New Role
          </Button>
        }
      ></Toolbar>
      <Card size="small" bodyStyle={{ padding: 0 }} style={{ marginTop: 16 }}>
        <Table size="small" loading={loading} rowKey="id" columns={columns} dataSource={roleList} pagination={false} />
        <RoleDlg />
      </Card>
    </Layout.Content>
  );
});
